if (!customElements.get('video-stats')) {
  customElements.define(
    'video-stats',
    class VideoStats extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleMotionPreference = this.handleMotionPreference.bind(this);
        this.motionPreference.addEventListener('change', this.handleMotionPreference);
        this.handleMotionPreference();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.motionPreference?.removeEventListener('change', this.handleMotionPreference);
      }

      handleMotionPreference() {
        this.observer?.disconnect();

        if (this.motionPreference.matches) {
          this.video.pause();
          return;
        }

        if (!('IntersectionObserver' in window)) {
          this.video.play().catch(() => {});
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.video.play().catch(() => {});
              } else {
                this.video.pause();
              }
            });
          },
          { rootMargin: '300px 0px', threshold: 0.01 }
        );

        this.observer.observe(this);
      }
    }
  );
}
